<template>
    <Modal
        :title="$t('billing.invoiceSettings')"
        @ok="confirm"
        @cancel="close"
        :cancel-text="$t('message.cancel')"
        :ok-text="$t('message.confirm')"
        :show-footer="true"
    >
        <div class="billing-configuration">
            <a-input-group>
                <label>{{$t("billing.invoiceEmailAddress")}}</label>
                <a-input v-model="email" :placeholder="$t('billing.defaultRootEmail')" />
            </a-input-group>
        </div>
    </Modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Modal from "../../../../components/common/Modal2.vue";
import { sendSocketMessage } from "../../../../utils/socketStream";

export default {
    name: "ConfigurationBilling",
    components: {
        Modal,
    },
    data: () => {
        return {
            email: "",
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
        }),
    },
    mounted() {
        this.email = this.settings.billContactEmail;
    },
    methods: {
        ...mapActions({
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        close() {
            this.$emit("close");
        },
        async confirm() {
            await this.setSettingValue({
                setting: "billContactEmail",
                value: this.email,
            });
            this.updateSettings({
                ...this.settings,
                billContactEmail: this.email,
            }).then((res) => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
                this.$emit("close");
                this.$message.success(this.$t("billing.billingContactInfo"));
            });
        },
    },
};
</script>

<style lang="scss">
.billing-configuration {
    .input-container {
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }

    .text-container {
        display: flex;
        flex-direction: column;
    }

    .description {
        margin-top: 5px;
        font-size: 12px;
        color: #888;
    }

    .checkbox {
        margin-right: 5px;
    }
}
</style>
